module.exports = __webpack_public_path__ + "img/upload.5779a74c.svg";